import React, { useContext } from 'react'
import { Controller, useFieldArray, useFormContext } from 'react-hook-form'
import { ClimaOptionsContext } from '../..'
import { Card, CardContent, Checkbox, Form } from 'semantic-ui-react'
import { FormFields } from '~/components/FormFields'

const PlantSelection:React.FC = () => {
  const { control, setValue, clearErrors } = useFormContext()
  const { plantProtections } = useContext(ClimaOptionsContext)

  const { fields, append, remove } = useFieldArray({
    control,
    name: 'grassSilage.plantProtections',
    keyName: 'key'
  })

  function renderPlantData(index) {
    return <>
      <FormFields.Input
        control={control}
        noErrorMessage
        name={`grassSilage.plantProtections[${index}].number`}
        placeholder={'in Behandlung(en)'}
        onChange={(event) => {
          setValue(`grassSilage.plantProtections[${index}].number`, event?.target?.value?.replace('Behandlung(en)', ''))
          clearErrors(`grassSilage.plantProtections[${index}].number`)
        }}
        typeInput='controled'
        suffix=' Behandlung(en)'
        label={'Anzahl'}
      />
      <FormFields.Input
        noErrorMessage
        control={control}
        name={`grassSilage.plantProtections[${index}].waterUsed`}
        placeholder={'in l/ha'}
        onChange={(event) => {
          setValue(`grassSilage.plantProtections[${index}].waterUsed`, event?.target?.value?.replace('l/ha', ''))
          clearErrors(`grassSilage.plantProtections[${index}].waterUsed`)
        }}
        typeInput='controled'
        label={'Ausbringmenge Wasser gesamt'}
        suffix=' l/ha'
      />
    </>
  }

  return <>
    <Controller
      name='grassSilage.plantProtections'
      render={({ fieldState: { error } }) => (
        <Form.Field error={Boolean(error)}>
          <label>{'Wählen Sie bzgl. Pflanzenschutz die jeweilige Behandlungsmaßnahme owie die Anzhal der Anwendungen und die Ausbringmenge an Wasser.'}</label>
          <div style={{ display: 'flex', gap: 20 }}>
            {plantProtections?.map((plantSelection, index) => {
              return <Checkbox
                key={plantSelection.id}
                label={plantSelection.label}
                checked={Boolean(fields.find(field => field['id'] === plantSelection.id))}
                onChange={(_, data) => {
                  if(data.checked) {
                    append({ ...plantSelection, waterUsed: '', number: '' })
                    return
                  }
                  remove(index)
                }}
              />
            })}
          </div>
        </Form.Field>
      )}
    />
    <div style={{ display: 'flex', alignItems: 'baseline', gap: 20, flexWrap: 'wrap', marginBottom: '2em' }}>
      {fields.map((plantSelection, index) => {
        return <Card key={plantSelection['id']}>
          <CardContent header={plantSelection['label']} />
          <CardContent description={renderPlantData(index)} />
        </Card>
      })}
    </div>
  </>
}
export default PlantSelection